import { LoadingProps } from './type';

const Loading = (props: LoadingProps) => {};

Loading.displayName = 'Loading';

export default Loading;
